<template>
  <el-dialog title="工单信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog"  width="90%" style="position: absolute; top: -40px;background-color: rgb(38 38 38 / 70%);"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" style="display:flex">

          <div class="table_main" style="height: 400px!important;">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
                      show-overflow height="390" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">
              <template #form>
<!--                <div class="clearfix screen-btns">-->
                  <div class="fr" style="display: inline-block;float:left;margin-bottom: 10px">
                    <vxe-button status="primary" icon="el-icon-add" class="button-sty"
                                @click="addPunishJob">新增
                    </vxe-button>
                  </div>
              </template>
              <template #option="{row}">
                <a href="javascript:void(0);" class="a-link" @click="doDetele(row.id)" v-if="row.runStat == 0 || row.runStat == 2">
                  删除
                </a>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
          <addPunishJobDialog v-if="showAddPunishJobDialog" @closeD="closeAddPunishJobDialog"
                         :visiable.sync="showAddPunishJobDialog"
                         multi="true"/>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
<!--			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>-->
<!--			<el-button type="primary" plain class="button-sty" @click="dialogClose">-->
<!--				<i class="el-icon-close el-icon"></i>-->
<!--				取 消-->
<!--			</el-button>-->
<!--			<el-button type="primary" @click="commitRow" class="button-sty">-->
<!--				<i class="el-icon-check el-icon"></i>-->
<!--				确 定-->
<!--			</el-button>-->
		</span>
  </el-dialog>
</template>

<script>
import {selectDialogMixins} from '@/mixins/selectDialog/index.js';
import {initVxeTable} from '@/const/crud/admin/table'

import pager from '@/components/pager/index.vue'
import api from "@/api/projectApi";
import addPunishJobDialog from "@/views/expense/wkPunishFee/addPunishJobDialog.vue";

export default {
  name: 'punishJobDialog',
  props: [],
  mixins: [selectDialogMixins],
  components: { pager,addPunishJobDialog},

  created() {

  },

  watch: {
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      showAddPunishJobDialog: false,
      columns: [
        { title: '任务时间', field: 'taskDate', width: 200, },
        {
          title: '数据类型', field: 'dataType', width: 125, slots: {
            default: ({ row }) => {
              if (row.dataType == 1) {
                return [
                  <span>星级奖励</span>
                ];
              } else if (row.dataType == 2) {
                return [
                  <span>区域奖励</span>
                ];
              }else if (row.dataType == 3) {
                return [
                  <span>翻倍奖励</span>
                ];
              }else if (row.dataType == 4) {
                return [
                  <span>好评奖励</span>
                ];
              }
            }
          }
        },
        { title: '工单开始时间', field: 'beginDate', width: 110, },
        { title: '工单结束时间', field: 'endDate', width: 110, },
        {
          title: '运行状态', field: 'runStat', width: 125, slots: {
            default: ({ row }) => {
              if (row.runStat == 0) {
                return [
                  <span>待运行</span>
                ];
              } else if (row.runStat == 1) {
                return [
                  <span>成功</span>
                ];
              }else if (row.runStat == 2) {
                return [
                  <span>失败</span>
                ];
              }
            }
          }
        },
        {
          title: '操作', field: '', width: 125, slots: {default: 'option'}
        },
      ],


      total: 0,
      searchOrderNo: null,
      data: [],
      showBigSiteName: null,

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
      },
      requestParam: {
        size: 0,
        current: 1,
        searchCount: false,
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchSiteName: '',
      selectedRow: {
        orderId: null, orderNo: null
      }
    };
  },




  methods: {
    doDetele(id){
      this.$baseConfirm('您确定要删除吗？').then(() => {
        this.$mask.open()
        this.$http({
          url: api.wkPunishFee.deletePunishJobUrl,
          method: 'post',
          data: {id:id},
        }).then(res => {
          this.$mask.close()
          this.$message({
            type: res.data.type,
            message: res.data.content
          });
          this.initTableList()
        }).catch(error => {
          this.$mask.close()
        })
      })
    },
    closeAddPunishJobDialog(type){
      this.showAddPunishJobDialog = false
      if (type == 1){
        this.initTableList()
      }
    },
    addPunishJob(){
      this.showAddPunishJobDialog = true
    },
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent(e) {
      console.log(e.row.id, '单元格点击事件')
    },

    dialogClose() {
      this.$emit('closeD')
    },



    commitRow() {
      this.$mask.open()

      if (this.selectedRow.orderNo !== null) {
        this.$emit('commit', this.selectedRow)
        this.dialogClose()
      } else {
        this.$message.warning('请先选中数据')
      }
      this.$mask.close()

    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      console.log("this.formData-------------------",this.formData)
      this.initTableList();
    },


    // 搜索
    searchEvent() {
      this.$objCopy(this.formData, this.requestParam)
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },


    initTableList() {
      this.$objCopy(this.formData, this.requestParam)
        let tableOption = {
          vue: this,
          tableRef: 'table-m1',
          path: api.wkPunishFee.getPunishOrderTaskPageUrl,
          param: this.requestParam,
          method: 'post',
          columns:  this.columns
        };
        this.vxeOption = initVxeTable(tableOption);

        this.flushed()

    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 400px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  width: 100%;
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}


::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}
::v-deep .vxe-grid .vxe-grid--pager-wrapper {
  display: block;
  width: 100%;
  position: fixed;
  bottom: -38px !important;
  position: absolute !important;
  z-index: 9999999;
  background-color: #ffffff;
}
</style>
